export function formatDeviceType(deviceType: string | undefined): string {
	if (!deviceType) return "";

	return deviceType.replace(/_\d+$/, "").replace(/_/g, " ");
}
